<template>
  <div
    :key="$store.getters['resource/currentResource'].key"
    class="white-container">
    <EmailView
      :fields="fields"
      :editing="true"
    />
  </div>
</template>

<script>
  import fields from './emailCreationFields.js';
  import EmailView from './EmailView';

  export default {
    name: 'EmailEditing',
    middleware: 'auth',
    components: {
      EmailView
    },
    computed: {
      id () {
        return this.$route.params.id || ''
      }
    },
    data () {
      return {
        fields: fields
      }
    },
    mounted () {
      if(!this.id){
        this.$router.push({path: '/emails'})
      }
    }
  }
</script>